import { isNative } from './isNative';

export default isNative;
